// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"89644fa0","161":"971f67a5","349":"59f595bf","385":"fd2f33cf","395":"dc724d61","424":"3ff0b9e4","588":"10abae59","635":"1964750f","654":"2de35b50","658":"f1e521b1","835":"c3009f6e","847":"488f6604","897":"41a3c6ea"}[chunkId] + ".chunk.js";
};